import React, { FC, FocusEvent } from 'react'
import { useFormikContext } from 'formik'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { Input, InputProps } from './Input'

type Props = Omit<InputProps, 'value' | 'onChange'> & {
  name: string
  onChange?: (value: string) => void
}

export const FormInput: FC<Props> = ({ name, onChange, onBlur, ...restProps }) => {
  const formik = useFormikContext<Record<string, string>>()
  const { tPrefix } = useAppTranslation('errorStatusMessage')

  const errorText = formik.errors[name]
  const value = formik.values[name]
  const isError = Boolean(errorText && formik.touched[name])

  const handleChange = (newValue: string) => {
    formik.setFieldValue(name, newValue)
    onChange?.(newValue)
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    formik.handleBlur(e)

    onBlur?.(e)
  }

  return (
    <Input
      name={name}
      value={value}
      onChange={handleChange}
      errorText={errorText && tPrefix(errorText)}
      isError={isError}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
